export default __webpack_public_path__ + "static/media/boite1.c2bef05f.jpg";